// Function to format client name (replace underscores with spaces and handle multiple patterns)
export const formatClientName = (name) => {
  if (!name) return name;

  return name.replace(/_+/g, ' ').replace(/\s+/g, ' ').trim();
};
